import { createContext } from 'react';
import { ConfirmationOptions } from './ConfirmDialog';

const ConfirmationContext = createContext<(options: ConfirmationOptions) => Promise<void>>(Promise.reject);

export default ConfirmationContext;
